import React, { useState, useEffect, useRef } from 'react';
import colors from '../../utils/colors';
import typography from '../../utils/typography';
import Waveform from './Waveform';
import EmptyWaveform from './EmptyWaveform';
import RecordedWaveform from './RecordedWaveform';
import Tooltip from './Tooltip';
import MediumButton from './MediumButton';
import {
  ChevronDownIcon,
  RecordIcon
} from '../../utils/icons';
import {
  CoverIcon,
  ExtendIcon,
  IntroIcon,
  SpeedIcon,
  ReplaceIcon,
  KaraokeIcon
} from './AudioPlayerIcons';


const PlayIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M4 12.4696V3.53036C4 3.28565 4.09218 3.08052 4.27654 2.91498C4.46091 2.74944 4.67599 2.66666 4.92181 2.66666C4.99863 2.66666 5.07929 2.67746 5.16379 2.69905C5.24829 2.72065 5.32894 2.75303 5.40576 2.79622L12.9185 7.26585C13.0568 7.35222 13.1605 7.46019 13.2296 7.58974C13.2988 7.7193 13.3333 7.85605 13.3333 8C13.3333 8.14395 13.2988 8.2807 13.2296 8.41025C13.1605 8.53981 13.0568 8.64777 12.9185 8.73414L5.40576 13.2038C5.32894 13.247 5.24829 13.2793 5.16379 13.3009C5.07929 13.3225 4.99863 13.3333 4.92181 13.3333C4.67599 13.3333 4.46091 13.2506 4.27654 13.085C4.09218 12.9195 4 12.7143 4 12.4696Z"
      fill="#FAF7F5"
    />
  </svg>
);

const PauseIcon = () => (
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 5.33333C4 4.59695 4.59695 4 5.33333 4C6.06971 4 6.66667 4.59695 6.66667 5.33333V10.6667C6.66667 11.403 6.06971 12 5.33333 12C4.59695 12 4 11.403 4 10.6667V5.33333Z" fill="#FAF7F5"/>
<path d="M9.33333 5.33333C9.33333 4.59695 9.93029 4 10.6667 4C11.403 4 12 4.59695 12 5.33333V10.6667C12 11.403 11.403 12 10.6667 12C9.93029 12 9.33333 11.403 9.33333 10.6667V5.33333Z" fill="#FAF7F5"/>
</svg>
);

const StopIcon = () => (
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 4C4 3.44772 4.44772 3 5 3H11C11.5523 3 12 3.44772 12 4V12C12 12.5523 11.5523 13 11 13H5C4.44772 13 4 12.5523 4 12V4Z" fill="#FAF7F5"/>
</svg>
);

const CloseIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M8.00003 8.93334L4.73337 12.2C4.61114 12.3222 4.45559 12.3833 4.2667 12.3833C4.07781 12.3833 3.92225 12.3222 3.80003 12.2C3.67781 12.0778 3.6167 11.9222 3.6167 11.7333C3.6167 11.5444 3.67781 11.3889 3.80003 11.2667L7.0667 8L3.80003 4.73334C3.67781 4.61111 3.6167 4.45556 3.6167 4.26667C3.6167 4.07778 3.67781 3.92222 3.80003 3.8C3.92225 3.67778 4.07781 3.61667 4.2667 3.61667C4.45559 3.61667 4.61114 3.67778 4.73337 3.8L8.00003 7.06667L11.2667 3.8C11.3889 3.67778 11.5445 3.61667 11.7334 3.61667C11.9223 3.61667 12.0778 3.67778 12.2 3.8C12.3223 3.92222 12.3834 4.07778 12.3834 4.26667C12.3834 4.45556 12.3223 4.61111 12.2 4.73334L8.93337 8L12.2 11.2667C12.3223 11.3889 12.3834 11.5444 12.3834 11.7333C12.3834 11.9222 12.3223 12.0778 12.2 12.2C12.0778 12.3222 11.9223 12.3833 11.7334 12.3833C11.5445 12.3833 11.3889 12.3222 11.2667 12.2L8.00003 8.93334Z"
      fill="#BAB4B1"
    />
  </svg>
);

const CheckIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-shrink-0 w-4 h-4 ml-auto"
  >
    <path
      d="M7.06666 11.0667L11.3 6.8334C11.56 6.5734 11.56 6.16007 11.3 5.90007C11.04 5.64007 10.6267 5.64007 10.3667 5.90007L7.06666 9.20007L5.63333 7.76674C5.37333 7.50674 4.95999 7.50674 4.69999 7.76674C4.43999 8.02674 4.43999 8.44007 4.69999 8.70007L7.06666 11.0667ZM7.99999 14.6667C7.07999 14.6667 6.21333 14.4934 5.39999 14.1401C4.58666 13.7934 3.87999 13.3134 3.27999 12.7134C2.67999 12.1134 2.20666 11.4067 1.85333 10.5934C1.50666 9.78007 1.32666 8.9134 1.32666 7.9934C1.32666 7.0734 1.49999 6.20674 1.85333 5.3934C2.20666 4.58007 2.67999 3.8734 3.27999 3.2734C3.87999 2.6734 4.58666 2.20007 5.39999 1.84674C6.21333 1.50007 7.07999 1.32007 7.99999 1.32007C8.91999 1.32007 9.78666 1.4934 10.6 1.84674C11.4133 2.70007 12.1133 2.6734 12.72 3.2734C13.32 3.8734 13.7933 4.58007 14.1467 5.3934C14.4933 6.20674 14.6733 7.0734 14.6733 7.9934C14.6733 8.9134 14.5 9.78007 14.1467 10.5934C13.7933 11.4067 13.32 12.1067 12.72 12.7134C12.12 13.3134 11.4133 13.7867 10.6 14.1401C9.78666 14.4934 8.91999 14.6667 7.99999 14.6667Z"
      fill="#FAF7F5"
    />
  </svg>
);

const CreateAudioPlayer = ({ 
  title = "Flow State",
  onPlay,
  onCover,
  onClose,
  audioSrc = "audio.mp3",
  image,
  isExtendMode = false,
  isReplaceSectionMode = false,
  isIntroMode = false,
  isSpeedMode = false,
  isFromWorkspace = false,
  className = "",
  onSpeedModeChange,
  onIntroLengthChange,
  onIntroModeChange,
  onExtendModeChange,
  onReplaceModeChange,
  onCoverModeChange,
  onKaraokeModeChange,
  selectedMode = "Custom",
  initialSelectedOption = "Cover",
  uploadState = "normal", // "normal", "uploading", "uploaded", "error"
  uploadProgress = 0,
  uploadRemainingTime = 0,
  onUploadCancel,
  uploadStartTime = null
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [progress, setProgress] = useState(0);
  const [showExtendOverlay, setShowExtendOverlay] = useState(false);
  const [showTrimOverlay, setShowTrimOverlay] = useState(false);
  const [showIntroOverlay, setShowIntroOverlay] = useState(false);
  const [showSpeedOverlay, setShowSpeedOverlay] = useState(false);
  const [extendStart, setExtendStart] = useState(0.7);
  const [trimStart, setTrimStart] = useState(0.2);
  const [trimEnd, setTrimEnd] = useState(0.8);
  const [introLength, setIntroLength] = useState(3);
  const [speedValue, setSpeedValue] = useState(1.0);
  const [speedSliderValue, setSpeedSliderValue] = useState(50); // Default to center (1.0x speed)
  const [keepPitch, setKeepPitch] = useState(false);
  const [selectedOption, setSelectedOption] = useState(initialSelectedOption);
  
  // Sync selectedOption with initialSelectedOption changes
  useEffect(() => {
    console.log('CreateAudioPlayer: initialSelectedOption changed to:', initialSelectedOption, 'current selectedOption:', selectedOption);
    if (initialSelectedOption !== selectedOption) {
      console.log('Updating selectedOption from', selectedOption, 'to', initialSelectedOption);
      setSelectedOption(initialSelectedOption);
    }
  }, [initialSelectedOption]);
  
  const [isDraggingExtend, setIsDraggingExtend] = useState(false);
  const [isDraggingTrim, setIsDraggingTrim] = useState(null);
  const [isDraggingIntro, setIsDraggingIntro] = useState(false);
  const [isDraggingSpeed, setIsDraggingSpeed] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showEmptyWaveform, setShowEmptyWaveform] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingProgress, setRecordingProgress] = useState(0);
  const [recordingWaveformData, setRecordingWaveformData] = useState([]);
  const [hasRecording, setHasRecording] = useState(false);
  const [recordingBlob, setRecordingBlob] = useState(null);
  const [recordedAudioProgress, setRecordedAudioProgress] = useState(0);
  const [recordedAudioCurrentTime, setRecordedAudioCurrentTime] = useState(0);
  const [recordedAudioDuration, setRecordedAudioDuration] = useState(0);
  const audioRef = useRef(null);
  const recordingAudioRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const recordingStartTimeRef = useRef(null);
  const isPlayingRef = useRef(isPlaying);
  const hasRecordingRef = useRef(hasRecording);
  const analyserRef = useRef(null);
  const audioContextRef = useRef(null);
  const hasInitializedKaraokeRef = useRef(false);
  
  // Keep refs in sync with state
  useEffect(() => {
    isPlayingRef.current = isPlaying;
  }, [isPlaying]);
  
  useEffect(() => {
    hasRecordingRef.current = hasRecording;
  }, [hasRecording]);

  // Track when modes are activated to notify parent
  const prevSelectedOptionRef = useRef(selectedOption);
  
  // TEMPORARILY DISABLED - Add debugging to see what's happening
  // useEffect(() => {
  //   console.log('Mode tracking useEffect - prev:', prevSelectedOptionRef.current, 'current:', selectedOption);
  //   // Handle Karaoke mode changes
  //   if (prevSelectedOptionRef.current === "Karaoke" && selectedOption !== "Karaoke" && onKaraokeModeChange) {
  //     onKaraokeModeChange(false);
  //   }
  //   if (selectedOption === "Karaoke" && prevSelectedOptionRef.current !== "Karaoke" && onKaraokeModeChange) {
  //     onKaraokeModeChange(true);
  //   }
  //   
  //   // Handle Cover mode changes
  //   if (prevSelectedOptionRef.current === "Cover" && selectedOption !== "Cover" && onCoverModeChange) {
  //     onCoverModeChange(false);
  //   }
  //   if (selectedOption === "Cover" && prevSelectedOptionRef.current !== "Cover" && onCoverModeChange) {
  //     onCoverModeChange(true);
  //   }
  //   
  //   prevSelectedOptionRef.current = selectedOption;
  // }, [selectedOption, onKaraokeModeChange, onCoverModeChange]);

  // Show empty waveform for Karaoke mode on initialization
  useEffect(() => {
    if (selectedOption === "Karaoke") {
      setShowEmptyWaveform(true);
    }
  }, [selectedOption]);


  // Audio event handlers
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleLoadedMetadata = () => {
      setDuration(audio.duration);
      console.log('Audio loaded successfully:', audioSrc, 'Duration:', audio.duration);
    };

    const handleTimeUpdate = () => {
      const currentProgress = audio.currentTime / audio.duration;
      
      // Update recorded audio progress to match main audio progress
      if (hasRecordingRef.current) {
        setRecordedAudioProgress(currentProgress);
      }
      
      // In extend mode, check if playhead goes past the end or before the start
      if (showExtendOverlay) {
        if (currentProgress >= 1) {
          // Reset to extend start when reaching the end
          audio.currentTime = extendStart * audio.duration;
          setCurrentTime(extendStart * audio.duration);
          setProgress(extendStart);
        } else if (currentProgress < extendStart) {
          // If somehow before extend start, move to extend start
          audio.currentTime = extendStart * audio.duration;
          setCurrentTime(extendStart * audio.duration);
          setProgress(extendStart);
        } else {
          setCurrentTime(audio.currentTime);
          setProgress(currentProgress);
        }
      } else if (showTrimOverlay) {
        // In trim mode, constrain playhead within trim bounds
        if (currentProgress >= trimEnd) {
          // Reset to trim start when reaching the end
          audio.currentTime = trimStart * audio.duration;
          setCurrentTime(trimStart * audio.duration);
          setProgress(trimStart);
        } else if (currentProgress < trimStart) {
          // If somehow before trim start, move to trim start
          audio.currentTime = trimStart * audio.duration;
          setCurrentTime(trimStart * audio.duration);
          setProgress(trimStart);
        } else {
          setCurrentTime(audio.currentTime);
          setProgress(currentProgress);
        }
      } else {
        setCurrentTime(audio.currentTime);
        setProgress(currentProgress);
      }
    };

    const handleEnded = () => {
      setIsPlaying(false);
      setCurrentTime(0);
      setProgress(0);
    };

    const handleError = (e) => {
      console.error('Audio error:', e, 'Source:', audioSrc);
      setIsPlaying(false);
    };

    const handleLoadStart = () => {
      console.log('Audio load started:', audioSrc);
    };

    const handleCanPlay = () => {
      console.log('Audio can play:', audioSrc);
    };

    audio.addEventListener('loadedmetadata', handleLoadedMetadata);
    audio.addEventListener('timeupdate', handleTimeUpdate);
    audio.addEventListener('ended', handleEnded);
    audio.addEventListener('error', handleError);
    audio.addEventListener('loadstart', handleLoadStart);
    audio.addEventListener('canplay', handleCanPlay);

    return () => {
      audio.removeEventListener('loadedmetadata', handleLoadedMetadata);
      audio.removeEventListener('timeupdate', handleTimeUpdate);
      audio.removeEventListener('ended', handleEnded);
      audio.removeEventListener('error', handleError);
      audio.removeEventListener('loadstart', handleLoadStart);
      audio.removeEventListener('canplay', handleCanPlay);
    };
  }, [audioSrc, showExtendOverlay, extendStart, showTrimOverlay, trimStart, trimEnd, showIntroOverlay, introLength]);

  // Recording audio event handlers - minimal setup for playback
  useEffect(() => {
    const recordingAudio = recordingAudioRef.current;
    if (!recordingAudio || !hasRecording) return;

    const handleLoadedMetadata = () => {
      const duration = recordingAudio.duration;
      console.log('Recording audio loaded successfully, Duration:', duration);
      
      // Handle case where duration is Infinity (streaming audio)
      if (duration === Infinity || isNaN(duration)) {
        console.warn('Recording audio duration is invalid, using main audio duration');
        setRecordedAudioDuration(audioRef.current?.duration || 0);
      } else {
        setRecordedAudioDuration(duration);
      }
    };

    const handleError = (e) => {
      console.error('Recording audio error:', e);
    };

    const handleEnded = () => {
      console.log('Recording audio ended');
    };

    // Add event listeners for playback functionality
    recordingAudio.addEventListener('loadedmetadata', handleLoadedMetadata);
    recordingAudio.addEventListener('ended', handleEnded);
    recordingAudio.addEventListener('error', handleError);

    return () => {
      recordingAudio.removeEventListener('loadedmetadata', handleLoadedMetadata);
      recordingAudio.removeEventListener('ended', handleEnded);
      recordingAudio.removeEventListener('error', handleError);
    };
  }, [hasRecording]);

  // Handle extend mode prop
  useEffect(() => {
    if (isExtendMode) {
      // Clear all other overlays first
      setShowTrimOverlay(false);
      setShowIntroOverlay(false);
      setShowSpeedOverlay(false);
      
      setShowExtendOverlay(true);
      setSelectedOption("Extend");
      
      // Initially position playhead 12px after the extend handle
      const handleOffset = 0.015; // Approximately 12px for most waveform widths
      const initialProgress = Math.min(1, extendStart + handleOffset);
      setProgress(initialProgress);
      
      // Update audio currentTime to match the initial position
      const audio = audioRef.current;
      if (audio && duration) {
        audio.currentTime = initialProgress * duration;
      }
    }
  }, [isExtendMode, extendStart, duration]);

  // Handle replace section mode prop
  useEffect(() => {
    if (isReplaceSectionMode) {
      // Clear all other overlays first
      setShowExtendOverlay(false);
      setShowIntroOverlay(false);
      setShowSpeedOverlay(false);
      
      setShowTrimOverlay(true);
      setSelectedOption("Replace");
      
      // Initially position playhead at trim start
      setProgress(trimStart);
      
      // Update audio currentTime to match the initial position
      const audio = audioRef.current;
      if (audio && duration) {
        audio.currentTime = trimStart * duration;
      }
    }
  }, [isReplaceSectionMode, trimStart, duration]);

  // Handle intro mode prop
  useEffect(() => {
    if (isIntroMode) {
      // Clear all other overlays first
      setShowExtendOverlay(false);
      setShowTrimOverlay(false);
      setShowSpeedOverlay(false);
      
      setShowIntroOverlay(true);
      setSelectedOption("Intro");
      
      // Position playhead at the very beginning (0:00) for intro mode
      setProgress(0);
      
      // Update audio currentTime to match the initial position
      const audio = audioRef.current;
      if (audio && duration) {
        audio.currentTime = 0;
      }
    }
  }, [isIntroMode, duration]);

  // Handle speed mode prop
  useEffect(() => {
    if (isSpeedMode) {
      // Clear all other overlays first
      setShowExtendOverlay(false);
      setShowTrimOverlay(false);
      setShowIntroOverlay(false);
      
      // Set speed mode
      setShowSpeedOverlay(true);
      setSelectedOption("Speed");
      
      // Position playhead at the very beginning (0:00) for speed mode
      setProgress(0);
      
      // Update audio currentTime to match the initial position
      const audio = audioRef.current;
      if (audio && duration) {
        audio.currentTime = 0;
      }
    } else {
      // If speed mode is turned off, hide the overlay
      setShowSpeedOverlay(false);
      // Don't reset selectedOption here - let other effects handle it
    }
  }, [isSpeedMode, duration]);

  // Ensure selectedOption stays in sync with speed mode
  useEffect(() => {
    if (isSpeedMode && showSpeedOverlay) {
      setSelectedOption("Speed");
    }
  }, [isSpeedMode, showSpeedOverlay]);

  // Additional sync for speed mode - ensure label is always correct
  useEffect(() => {
    if (isSpeedMode) {
      setSelectedOption("Speed");
    } else if (!isSpeedMode && selectedOption === "Speed") {
      // If we're switching away from speed mode and the current selection is Speed,
      // reset to Cover unless another overlay is active
      const hasOtherOverlay = showExtendOverlay || showTrimOverlay || showIntroOverlay;
      if (!hasOtherOverlay) {
        setSelectedOption("Cover");
      }
    }
  }, [isSpeedMode, selectedOption, showExtendOverlay, showTrimOverlay, showIntroOverlay]);

  // Initialize mode from props on mount only - don't override user interactions
  useEffect(() => {
    // Only initialize on mount or when switching between workspace modes
    // Don't override user dropdown selections or active overlays
    const hasActiveOverlay = showExtendOverlay || showTrimOverlay || showIntroOverlay || showSpeedOverlay;
    
    // Don't override if there's already an active overlay or if we're not from workspace
    if (!hasActiveOverlay || isFromWorkspace) {
      if (isSpeedMode) {
        setSelectedOption("Speed");
      } else if (isExtendMode) {
        setSelectedOption("Extend");
      } else if (isReplaceSectionMode) {
        setSelectedOption("Replace");
      } else if (isIntroMode) {
        setSelectedOption("Intro");
      } else if (initialSelectedOption === "Karaoke") {
        console.log('🔄 Keeping Karaoke mode from initialSelectedOption');
        setSelectedOption("Karaoke");
      } else if (!hasActiveOverlay) {
        // Only set to Cover if no overlays are active and not Karaoke
        console.log('🔄 Defaulting to Cover mode');
        setSelectedOption("Cover");
      }
    }
  }, [isExtendMode, isReplaceSectionMode, isIntroMode, isSpeedMode, isFromWorkspace, showExtendOverlay, showTrimOverlay, showIntroOverlay, showSpeedOverlay, initialSelectedOption]);

  // Handle extend position changes
  const handleExtendChange = (newPosition) => {
    setExtendStart(newPosition);
    
    // Move progress to a position right after the handle (12px offset)
    // Use a small percentage offset that approximates 12px in the waveform
    const handleOffset = 0.015; // Approximately 12px for most waveform widths
    const newProgress = Math.min(1, newPosition + handleOffset);
    setProgress(newProgress);
    
    // Update audio currentTime to match the new position
    const audio = audioRef.current;
    if (audio && duration) {
      audio.currentTime = newProgress * duration;
    }
  };

  // Handle extend drag state changes
  const handleExtendDragChange = (isDragging) => {
    setIsDraggingExtend(isDragging);
  };

  // Handle trim position changes
  const handleTrimChange = (start, end) => {
    const newTrimStart = Math.max(0, Math.min(start, end - 0.01));
    const newTrimEnd = Math.max(start + 0.01, Math.min(1, end));
    
    setTrimStart(newTrimStart);
    setTrimEnd(newTrimEnd);
    
    // Move progress to the new trim start position
    setProgress(newTrimStart);
    
    // Update audio currentTime to match the new position
    const audio = audioRef.current;
    if (audio && duration) {
      audio.currentTime = newTrimStart * duration;
    }
  };

  // Handle trim drag state changes
  const handleTrimDragChange = (dragState) => {
    setIsDraggingTrim(dragState);
  };

  const handleIntroDragChange = (dragState) => {
    setIsDraggingIntro(dragState);
  };

  const handleIntroChange = (newLength) => {
    setIntroLength(newLength);
    onIntroLengthChange?.(newLength);
  };

  // Handle speed changes
  const handleSpeedChange = (newSpeed) => {
    setSpeedValue(newSpeed);
    // Apply playback rate to audio if needed
    const audio = audioRef.current;
    if (audio) {
      audio.playbackRate = newSpeed;
    }
  };

  // Convert slider value (0-100) to speed with 1.0x at center (50%)
  const sliderToSpeed = (sliderValue) => {
    if (sliderValue <= 50) {
      // 0-50% maps to 0.25x-1.0x
      return 0.25 + (sliderValue / 50) * (1.0 - 0.25);
    } else {
      // 50-100% maps to 1.0x-4.0x
      return 1.0 + ((sliderValue - 50) / 50) * (4.0 - 1.0);
    }
  };

  // Convert speed to slider value with 1.0x at center (50%)
  const speedToSlider = (speed) => {
    if (speed <= 1.0) {
      // 0.25x-1.0x maps to 0-50%
      return ((speed - 0.25) / (1.0 - 0.25)) * 50;
    } else {
      // 1.0x-4.0x maps to 50-100%
      return 50 + ((speed - 1.0) / (4.0 - 1.0)) * 50;
    }
  };

  const handleSpeedSliderChange = (sliderValue) => {
    setSpeedSliderValue(sliderValue);
    const newSpeed = sliderToSpeed(sliderValue);
    handleSpeedChange(Math.round(newSpeed * 100) / 100); // Round to 2 decimal places
  };

  const handleSpeedDragChange = (isDragging) => {
    setIsDraggingSpeed(isDragging);
  };

  const handleKeepPitchToggle = () => {
    setKeepPitch(!keepPitch);
    // Apply pitch correction if needed
    const audio = audioRef.current;
    if (audio) {
      audio.preservesPitch = keepPitch;
    }
  };

  // Calculate current time for tooltip
  const getExtendTime = () => {
    return extendStart * duration;
  };

  const getTrimStartTime = () => {
    return trimStart * duration;
  };

  const getTrimEndTime = () => {
    return trimEnd * duration;
  };

  const getIntroTime = () => {
    // Calculate intro time based on bars (assuming 120 BPM, each bar = 2 seconds)
    return introLength * 2;
  };

  // Handle collapse toggle
  const handleCollapseToggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  // Format time helper
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Recording functionality
  const startRecording = async () => {
    try {
      // Store original volume and reduce main track for isolation
      const mainAudio = audioRef.current;
      if (mainAudio) {
        mainAudio.volume = 0.15; // Reduce to 15% during recording
        console.log('Main track volume reduced to 15% for vocal isolation');
      }
      
      // Enhanced audio constraints for vocal isolation
      const stream = await navigator.mediaDevices.getUserMedia({ 
        audio: {
          echoCancellation: true,        // Cancel speaker audio bleeding into mic
          noiseSuppression: true,        // Reduce background noise
          autoGainControl: true,         // Automatically adjust mic sensitivity
          sampleRate: 44100,            // High quality sample rate
          channelCount: 1,              // Mono recording for better processing
          latency: 0.01,                // Low latency for real-time feel
          volume: 1.0                   // Full volume capture
        }
      });
      
      // Create audio context for real-time processing
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      audioContextRef.current = audioContext;
      const source = audioContext.createMediaStreamSource(stream);
      
      // Create analyser for real-time waveform visualization
      const analyser = audioContext.createAnalyser();
      analyser.fftSize = 256;
      analyser.smoothingTimeConstant = 0.8;
      analyserRef.current = analyser;
      
      // High-pass filter to reduce speaker bleed (vocals are typically 300Hz+)
      const highPassFilter = audioContext.createBiquadFilter();
      highPassFilter.type = 'highpass';
      highPassFilter.frequency.value = 200; // Remove low frequencies from speakers
      highPassFilter.Q.value = 0.5;
      
      // Compressor to even out vocal dynamics
      const compressor = audioContext.createDynamicsCompressor();
      compressor.threshold.value = -24;    // Start compressing at -24dB
      compressor.knee.value = 30;          // Smooth compression curve
      compressor.ratio.value = 8;          // 8:1 compression ratio
      compressor.attack.value = 0.003;     // Fast attack for vocals
      compressor.release.value = 0.25;     // Medium release
      
      // Create destination for processed audio
      const destination = audioContext.createMediaStreamDestination();
      
      // Connect the audio processing chain with analyser
      source.connect(analyser);
      source.connect(highPassFilter);
      highPassFilter.connect(compressor);
      compressor.connect(destination);
      
      // Use the processed stream for recording
      const processedStream = destination.stream;
      
      const mediaRecorder = new MediaRecorder(processedStream, {
        mimeType: 'audio/webm;codecs=opus', // Better compression for vocals
        audioBitsPerSecond: 128000           // Good quality for vocals
      });
      mediaRecorderRef.current = mediaRecorder;
      
      const chunks = [];
      mediaRecorder.ondataavailable = (event) => {
        chunks.push(event.data);
      };
      
      mediaRecorder.onstop = () => {
        const blob = new Blob(chunks, { type: 'audio/wav' });
        setRecordingBlob(blob);
        setHasRecording(true);
        
        // Create audio URL for playback
        const audioUrl = URL.createObjectURL(blob);
        if (recordingAudioRef.current) {
          recordingAudioRef.current.src = audioUrl;
        }
        
        console.log('Recording completed', blob);
      };
      
      mediaRecorder.start();
      setIsRecording(true);
      recordingStartTimeRef.current = Date.now();
      
      // Start the main audio playback in sync
      if (!isPlaying) {
        handleMainAudioPlayPause();
      }
      
      console.log('Recording started with vocal isolation enabled');
      
      // Optional: Show recording tips to user
      if (typeof window !== 'undefined' && window.console) {
        console.log('🎤 Recording Tips:');
        console.log('• Keep microphone 6-8 inches from your mouth');
        console.log('• Speak/sing clearly and consistently');
        console.log('• Lower speaker volume to 40-50% if possible');
        console.log('• Echo cancellation and noise suppression are active');
      }
    } catch (error) {
      console.error('Error starting recording:', error);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
    }
    
    // Stop main audio playback and reset to beginning
    const audio = audioRef.current;
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
      audio.volume = 1.0; // Restore full volume after recording
      setIsPlaying(false);
      setProgress(0);
      setCurrentTime(0);
      console.log('Main track volume restored to 100%');
    }
    
    // Reset recording audio to beginning as well
    const recordingAudio = recordingAudioRef.current;
    if (recordingAudio) {
      recordingAudio.currentTime = 0;
    }
    
    // Clean up audio context and analyser
    if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
      audioContextRef.current.close();
    }
    analyserRef.current = null;
    audioContextRef.current = null;
    
    setIsRecording(false);
    setRecordingProgress(0);
    console.log('Recording stopped, waveform data length:', recordingWaveformData.length);
  };

  // Update recording progress and waveform
  useEffect(() => {
    let intervalId;
    if (isRecording && recordingStartTimeRef.current) {
      intervalId = setInterval(() => {
        const elapsed = (Date.now() - recordingStartTimeRef.current) / 1000;
        const recordingProgressPercent = Math.min(elapsed / duration, 1);
        setRecordingProgress(recordingProgressPercent);
        
        // Real-time waveform data generation from microphone input
        if (analyserRef.current) {
          const bufferLength = analyserRef.current.frequencyBinCount;
          const dataArray = new Uint8Array(bufferLength);
          analyserRef.current.getByteFrequencyData(dataArray);
          
          // Calculate RMS (Root Mean Square) for overall volume level
          let sum = 0;
          for (let i = 0; i < bufferLength; i++) {
            sum += dataArray[i] * dataArray[i];
          }
          const rms = Math.sqrt(sum / bufferLength);
          
          // Convert RMS to bar height (0-255 range from analyser, scale to 2-48px)
          // Apply noise gate: only show bars above threshold (around 10-15)
          const noiseGate = 12; // Threshold below which we show minimal bars
          let barHeight;
          
          if (rms < noiseGate) {
            // Below noise gate - show minimal bar
            barHeight = 2;
          } else {
            // Above noise gate - scale the signal
            const scaledRMS = ((rms - noiseGate) / (255 - noiseGate)) * 46; // Scale to 0-46
            barHeight = Math.max(2, Math.min(48, scaledRMS + 2)); // Add 2px minimum, cap at 48px
          }
          
          setRecordingWaveformData(prev => {
            const newData = [...prev, Math.floor(barHeight)];
            return newData.slice(-140); // Keep last 140 bars
          });
        } else {
          // Fallback if analyser is not available - show minimal bars
          setRecordingWaveformData(prev => {
            const newData = [...prev, 2];
            return newData.slice(-140);
          });
        }
      }, 100);
    }
    
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isRecording, duration]);

  // Combined play/pause and recording handler
  const handlePlayPause = async () => {
    console.log('handlePlayPause called, showEmptyWaveform:', showEmptyWaveform, 'isRecording:', isRecording, 'hasRecording:', hasRecording);
    
    // If empty waveform is showing (recording mode)
    if (showEmptyWaveform) {
      if (isRecording) {
        console.log('Stopping recording');
        stopRecording();
      } else if (hasRecording) {
        // Play both main audio and recording in sync
        // console.log('🎵 CALLING NEW PLAYAUDIOS FUNCTION 🎵');
        await playBothAudios();
      } else {
        console.log('Starting recording');
        await startRecording();
      }
      return;
    }
    
    // Normal play/pause for main audio
    console.log('Playing main audio only');
    await handleMainAudioPlayPause();
  };

  // Play main audio and recorded vocals together
  const playBothAudios = async () => {
    const mainAudio = audioRef.current;
    const recordedAudio = recordingAudioRef.current;
    
    if (!mainAudio) return;
    
    try {
      if (isPlaying) {
        // Pause both audios
        mainAudio.pause();
        if (recordedAudio) {
          recordedAudio.pause();
        }
        setIsPlaying(false);
      } else {
        // Sync both audios to the same position before playing
        if (recordedAudio) {
          recordedAudio.currentTime = mainAudio.currentTime;
        }
        
        // Play both audios together
        const playPromises = [mainAudio.play()];
        if (recordedAudio) {
          playPromises.push(recordedAudio.play());
        }
        
        await Promise.all(playPromises);
        setIsPlaying(true);
        
        console.log('Playing main audio + recorded vocals together');
      }
    } catch (error) {
      console.error('Error playing synchronized audio:', error);
    }
  };

  // Main audio play/pause handler
  const handleMainAudioPlayPause = async () => {
    const audio = audioRef.current;
    if (!audio) {
      console.error('Audio ref not available');
      return;
    }

    console.log('Play/pause clicked, current state:', { isPlaying, audioSrc, duration, readyState: audio.readyState });

    try {
      if (isPlaying) {
        audio.pause();
        setIsPlaying(false);
        console.log('Audio paused');
      } else {
        // Check if audio is ready to play
        if (audio.readyState < 2) {
          console.log('Audio not ready, readyState:', audio.readyState);
        }
        await audio.play();
        setIsPlaying(true);
        console.log('Audio playing');
      }
      onPlay?.();
    } catch (error) {
      console.error('Error playing audio:', error, {
        audioSrc,
        readyState: audio.readyState,
        networkState: audio.networkState,
        error: audio.error
      });
      setIsPlaying(false);
    }
  };

  // Progress change handler for Waveform
  const handleProgressChange = (newProgress) => {
    const audio = audioRef.current;
    if (audio && duration) {
      const newTime = newProgress * duration;
      audio.currentTime = newTime;
      setCurrentTime(newTime);
      setProgress(newProgress);
    }
  };

  // Handle option selection
  const handleOptionSelect = (option) => {
    console.log('🔧 handleOptionSelect called with option:', option);
    setSelectedOption(option);
    
    // Reset all overlays first
    setShowExtendOverlay(false);
    setShowTrimOverlay(false);
    setShowIntroOverlay(false);
    setShowSpeedOverlay(false);
    
    // Notify parent about mode changes when switching away from modes
    if (onSpeedModeChange && option !== "Speed") {
      onSpeedModeChange(false);
    }
    if (onIntroModeChange && option !== "Intro") {
      onIntroModeChange(false);
    }
    if (onExtendModeChange && option !== "Extend") {
      onExtendModeChange(false);
    }
    if (onReplaceModeChange && option !== "Replace") {
      onReplaceModeChange(false);
    }
    // Hide empty waveform when switching away from Karaoke mode
    if (option !== "Karaoke") {
      setShowEmptyWaveform(false);
    }
    
    // Show specific overlay based on option and reset playhead position
    const audio = audioRef.current;
    
    switch (option) {
      case "Extend":
        setShowExtendOverlay(true);
        // Position playhead at the beginning of the extend selection
        const handleOffset = 0.015; // Approximately 12px for most waveform widths
        const extendProgress = Math.min(1, extendStart + handleOffset);
        setProgress(extendProgress);
        if (audio && duration) {
          audio.currentTime = extendProgress * duration;
        }
        // Notify parent about extend mode change
        if (onExtendModeChange) {
          onExtendModeChange(true);
        }
        break;
      case "Replace":
        setShowTrimOverlay(true);
        // Position playhead at the beginning of the trim selection
        setProgress(trimStart);
        if (audio && duration) {
          audio.currentTime = trimStart * duration;
        }
        // Notify parent about replace mode change
        if (onReplaceModeChange) {
          onReplaceModeChange(true);
        }
        break;
      case "Intro":
        setShowIntroOverlay(true);
        // Position playhead at 0:00 for intro mode
        setProgress(0);
        if (audio && duration) {
          audio.currentTime = 0;
        }
        // Notify parent about intro mode change
        if (onIntroModeChange) {
          onIntroModeChange(true);
        }
        break;
      case "Speed":
        setShowSpeedOverlay(true);
        // Position playhead at 0:00 for speed mode
        setProgress(0);
        if (audio && duration) {
          audio.currentTime = 0;
        }
        // Notify parent about speed mode change
        if (onSpeedModeChange) {
          onSpeedModeChange(true);
        }
        break;
      case "Cover":
        // Position playhead at 0:00 for cover mode
        setProgress(0);
        if (audio && duration) {
          audio.currentTime = 0;
        }
        // Reset any speed settings
        if (audio) {
          audio.playbackRate = 1.0;
          audio.preservesPitch = true;
        }
        onCover?.();
        break;
      case "Karaoke":
        // Position playhead at 0:00 for karaoke mode
        setProgress(0);
        if (audio && duration) {
          audio.currentTime = 0;
        }
        // Reset any speed settings
        if (audio) {
          audio.playbackRate = 1.0;
          audio.preservesPitch = true;
        }
        // Show empty waveform by default for karaoke mode
        setShowEmptyWaveform(true);
        break;
      default:
        console.log(`${option} clicked`);
    }
  };

  // Close dropdown when clicking outside

  // Upload State Components
  const renderUploadingState = () => (
    <div 
      className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 gap-2 p-4 rounded-2xl"
      style={{ backgroundColor: colors.bg.secondary }}
    >
      <div className="flex justify-start items-center flex-grow-0 flex-shrink-0 gap-2">
        <div className="flex flex-col justify-center items-start flex-grow-0 flex-shrink-0 relative">
          <p className="flex-grow-0 flex-shrink-0 text-sm font-medium text-center text-white">
            {title}
          </p>
          <p 
            className="flex-grow-0 flex-shrink-0 text-sm text-center"
            style={{ color: colors.text.tertiary }}
          >
            Uploading....
          </p>
        </div>
      </div>
      <div className="flex flex-col justify-start items-start flex-grow h-3 relative gap-2.5 rounded-[100px] bg-white/10">
        <div 
          className="flex-grow-0 flex-shrink-0 h-3 rounded-[100px]"
          style={{ 
            backgroundColor: colors.accent.brand,
            width: uploadState === "uploading" ? '100%' : `${uploadProgress}%`,
            transition: uploadState === "uploading" 
              ? 'width 5s linear' 
              : 'width 0.2s ease'
          }}
        />
      </div>
      <div 
        className="flex justify-center items-center flex-grow-0 flex-shrink-0 h-10 relative gap-1 px-4 rounded-[100px] cursor-pointer hover:bg-opacity-80 transition-colors"
        style={{ backgroundColor: colors.bg.secondary }}
        onClick={onUploadCancel}
      >
        <p className="flex-grow w-[37px] text-xs font-medium text-left text-white">Cancel</p>
      </div>
    </div>
  );

  const renderUploadedState = () => (
    <div 
      className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 gap-2 p-4 rounded-2xl"
      style={{ backgroundColor: colors.bg.secondary }}
    >
      <div className="flex justify-start items-center flex-grow-0 flex-shrink-0 gap-2">
        <div className="flex flex-col justify-center items-start flex-grow-0 flex-shrink-0 relative">
          <p className="flex-grow-0 flex-shrink-0 text-sm font-medium text-center text-white">
            {title}
          </p>
          <p 
            className="flex-grow-0 flex-shrink-0 text-sm text-center"
            style={{ color: colors.text.tertiary }}
          >
            Uploaded!
          </p>
        </div>
      </div>
      <div className="flex flex-col justify-start items-start flex-grow h-3 relative gap-2.5 rounded-[100px] bg-white/10">
        <div 
          className="self-stretch flex-grow-0 flex-shrink-0 h-3 rounded-[100px]"
          style={{ backgroundColor: colors.states.success }}
        />
      </div>
      <div 
        className="flex justify-center items-center flex-grow-0 flex-shrink-0 h-10 relative gap-1 px-4 rounded-[100px] cursor-pointer hover:bg-opacity-80 transition-colors"
        style={{ backgroundColor: colors.bg.secondary }}
        onClick={onUploadCancel}
      >
        <p className="flex-grow w-[37px] text-xs font-medium text-left text-white">Cancel</p>
      </div>
    </div>
  );

  const renderErrorState = () => (
    <div 
      className="flex justify-between items-center self-stretch flex-grow-0 flex-shrink-0 relative p-4 rounded-2xl"
      style={{ backgroundColor: colors.bg.secondary }}
    >
      <div className="flex justify-start items-center flex-grow-0 flex-shrink-0 gap-2">
        <div className="flex flex-col justify-center items-start flex-grow-0 flex-shrink-0 relative">
          <p className="flex-grow-0 flex-shrink-0 text-sm font-medium text-center text-white">
            Error uploading
          </p>
          <p 
            className="flex-grow-0 flex-shrink-0 text-sm text-center"
            style={{ color: colors.states.danger }}
          >
            There was an error with your audio
          </p>
        </div>
      </div>
      <div 
        className="cursor-pointer"
        onClick={onUploadCancel}
      >
        <CloseIcon />
      </div>
    </div>
  );

  // Render upload states
  if (uploadState === "uploading") return renderUploadingState();
  if (uploadState === "uploaded") return renderUploadedState();
  if (uploadState === "error") return renderErrorState();

  return (
    <div 
      className={`flex flex-col justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative gap-4 p-4 rounded-2xl ${className}`}
      style={{ backgroundColor: colors.bg.secondary }}
    >
      {/* Header Controls */}
      <div className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative gap-4">
        {/* Play Button */}
        <MediumButton
          variant="secondary"
          onClick={handlePlayPause}
          leftIcon={
            showEmptyWaveform 
              ? (isRecording 
                  ? <StopIcon /> 
                  : (hasRecording 
                      ? (isPlaying ? <PauseIcon /> : <PlayIcon />)
                      : <RecordIcon />
                    )
                )
              : (isPlaying ? <PauseIcon /> : <PlayIcon />)
          }
          style={{
            ...(showEmptyWaveform && !hasRecording ? { backgroundColor: colors.states.danger } : {}),
            ...(isRecording ? { 
              animation: 'pulse 1.5s ease-in-out infinite',
              backgroundColor: colors.states.danger
            } : {})
          }}
          className={isRecording ? 'recording-pulse' : ''}
        />
        
        {/* Song Info */}
        <div className="flex justify-start items-center flex-grow relative gap-2 min-w-0">
          {image && (
            <div 
              className="flex-grow-0 flex-shrink-0 w-8 h-8 relative overflow-hidden rounded bg-white"
              style={{
                backgroundImage: `url(${image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />
          )}
          <div className="flex flex-col justify-center items-start flex-grow min-w-0">
            <p className="text-xs font-medium text-left text-white truncate w-full">
              {title}
            </p>
            <p 
              className="text-left whitespace-nowrap"
              style={{ ...typography.duration, color: colors.text.tertiary }}
            >
              {formatTime(currentTime)} / {formatTime(duration)}
            </p>
          </div>
        </div>

        
        {/* Audio Mode Dropdown */}
        {console.log('🎵 CreateAudioPlayer rendering MediumButton - title:', title, 'selectedOption:', selectedOption)}
        <MediumButton
          text="Mode" // Ignored when showSelectedLabel=true
          showSelectedLabel={true}
          variant="secondary"
          dropdownOptions={[
            { value: "Cover", label: "Cover", icon: <CoverIcon /> },
            { value: "Extend", label: "Extend", icon: <ExtendIcon /> },
            ...(selectedMode === "Custom" ? [{ value: "Intro", label: "Intro", icon: <IntroIcon /> }] : []),
            { value: "Speed", label: "Speed", icon: <SpeedIcon /> },
            ...(selectedMode === "Custom" ? [{ value: "Replace", label: "Replace", icon: <ReplaceIcon /> }] : [])
          ]}
          dropdownValue={selectedOption}
          onDropdownChange={handleOptionSelect}
          dropdownPosition="bottom-right"
          dropdownWidth={160}
        />
        
        {/* Close/Collapse Button */}
        {isFromWorkspace ? (
          <div
            className="w-4 h-4 flex items-center justify-center transition-transform duration-300 cursor-pointer hover:opacity-70"
            style={{ 
              transform: isCollapsed ? 'rotate(0deg)' : 'rotate(180deg)'
            }}
            onClick={handleCollapseToggle}
          >
            <ChevronDownIcon
              style={{ color: colors.text.tertiary }}
            />
          </div>
        ) : (
          <button 
            className="flex-grow-0 flex-shrink-0 w-4 h-4 relative hover:opacity-70 transition-opacity"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        )}
      </div>
      
      {/* Recording Waveforms for Cover and Karaoke Mode - Above main waveform */}
      {showEmptyWaveform && (selectedOption === "Cover" || selectedOption === "Karaoke") && !isCollapsed && (
        hasRecording ? (
          <RecordedWaveform 
            onClose={() => {
              if (selectedOption === "Karaoke") {
                // In Karaoke mode, reset to empty waveform instead of hiding completely
                setHasRecording(false);
                setRecordingWaveformData([]);
                setRecordingBlob(null);
                // Keep showEmptyWaveform true to show the empty state
              } else {
                // In Cover mode, hide the waveform completely
                setShowEmptyWaveform(false);
                setHasRecording(false);
                setRecordingWaveformData([]);
                setRecordingBlob(null);
              }
            }}
            className="self-stretch mb-1"
            recordingWaveformData={recordingWaveformData}
            progress={recordedAudioProgress}
            isPlaying={isPlaying}
            showCloseButton={true}
          />
        ) : (
          <EmptyWaveform 
            onClose={() => {
              setShowEmptyWaveform(false);
              if (isRecording) {
                stopRecording();
              }
            }}
            className="self-stretch mb-1"
            isRecording={isRecording}
            recordingWaveformData={recordingWaveformData}
            recordingProgress={recordingProgress}
            showCloseButton={selectedOption !== "Karaoke"}
          />
        )
      )}

      {/* Waveform Visualization - Hidden when collapsed */}
      {!isCollapsed && (
        <Waveform
          audioSrc={audioSrc}
          progress={progress}
          onProgressChange={handleProgressChange}
          isPlaying={isPlaying}
          showTrimHandles={showTrimOverlay}
          trimStart={trimStart}
          trimEnd={trimEnd}
          onTrimChange={handleTrimChange}
          showExtendOverlay={showExtendOverlay}
          extendStart={extendStart}
          onExtendChange={handleExtendChange}
          onExtendDragChange={handleExtendDragChange}
          showIntroOverlay={showIntroOverlay}
          introLength={introLength}
          onIntroChange={handleIntroChange}
          onIntroDragChange={handleIntroDragChange}
          onTrimDragChange={handleTrimDragChange}
          showPlusButton={false}
          className="self-stretch"
        />
      )}

      {/* Extend Tooltip */}
      {isDraggingExtend && showExtendOverlay && !isCollapsed && (
        <div 
          className="absolute pointer-events-none"
          style={{
            left: `calc(0.75rem + ${extendStart} * (100% - 1.5rem))`,
            top: 'calc(100% - 84px - 12px)',
            zIndex: 40
          }}
        >
          <Tooltip
            text={"Extend from " + formatTime(getExtendTime())}
            isVisible={true}
            position="top"
            offset={4}
          />
        </div>
      )}

      {/* Trim Start Tooltip */}
      {isDraggingTrim === 'start' && showTrimOverlay && !isCollapsed && (
        <div 
          className="absolute pointer-events-none"
          style={{
            left: `calc(0.75rem + ${trimStart} * (100% - 1.5rem))`,
            top: 'calc(100% - 84px - 12px)',
            zIndex: 40
          }}
        >
          <Tooltip
            text={formatTime(getTrimStartTime())}
            isVisible={true}
            position="top"
            offset={4}
          />
        </div>
      )}
      
      {/* Trim End Tooltip */}
      {isDraggingTrim === 'end' && showTrimOverlay && !isCollapsed && (
        <div 
          className="absolute pointer-events-none"
          style={{
            left: `calc(0.75rem + ${trimEnd} * (100% - 1.5rem))`,
            top: 'calc(100% - 84px - 12px)',
            zIndex: 40
          }}
        >
          <Tooltip
            text={formatTime(getTrimEndTime())}
            isVisible={true}
            position="top"
            offset={4}
          />
        </div>
      )}

      {/* Intro Tooltip */}
      {isDraggingIntro && showIntroOverlay && !isCollapsed && (
        <div 
          className="absolute pointer-events-none"
          style={{
            left: `${introLength * 20}px`,
            top: 'calc(100% - 84px - 12px)',
            zIndex: 40
          }}
        >
          <Tooltip
            text={`${introLength} bars`}
            isVisible={true}
            position="top"
            offset={4}
          />
        </div>
      )}

      {/* Speed Mode Overlay */}
      {showSpeedOverlay && !isCollapsed && (
        <div className="flex flex-col gap-2 w-full">
          {/* Speed Slider */}
          <div 
            className="border border-white/10 rounded-lg px-4 py-2 h-[48px] flex justify-between items-center space-x-3 relative cursor-default w-full" 
            style={{ backgroundColor: colors.bg.primary }}
          >
            <div className="flex items-center space-x-1 flex-shrink-0 pointer-events-none">
              <span className="text-xs font-medium w-[100px] text-left" style={{ color: colors.text.primary }}>
                Speed
              </span>
            </div>
            <div 
              className="relative flex-1 h-6 flex items-center justify-center cursor-pointer select-none mx-3" 
              onMouseDown={(e) => {
                e.preventDefault();
                setIsDraggingSpeed(true);
                
                const sliderElement = e.currentTarget;
                
                const handleMouseMove = (e) => {
                  const rect = sliderElement.getBoundingClientRect();
                  const handleWidth = 10;
                  const positionInTrack = e.clientX - rect.left;
                  const handleCenterPosition = positionInTrack - (handleWidth / 2);
                  const newValue = (handleCenterPosition / (rect.width - handleWidth)) * 100;
                  const clampedValue = Math.max(0, Math.min(100, Math.round(newValue)));
                  handleSpeedSliderChange(clampedValue);
                };
                
                const handleMouseUp = () => {
                  setIsDraggingSpeed(false);
                  document.removeEventListener('mousemove', handleMouseMove);
                  document.removeEventListener('mouseup', handleMouseUp);
                };
                
                document.addEventListener('mousemove', handleMouseMove);
                document.addEventListener('mouseup', handleMouseUp);
                
                // Handle immediate click
                handleMouseMove(e);
              }}
              onDoubleClick={() => {
                const defaultSliderValue = speedToSlider(1.0); // 1.0x speed
                setSpeedSliderValue(defaultSliderValue);
                handleSpeedChange(1.0);
              }}
            >
              {/* Slider Track */}
              <div className="flex items-center justify-between h-6 w-full relative pointer-events-none">
                {Array.from({ length: 11 }, (_, index) => {
                  // Use smooth continuous calculation instead of rounded values
                  const centerPosition = speedSliderValue / 10;
                  const distance = Math.abs(index - centerPosition);
                  let opacity;
                  
                  if (distance <= 4) {
                    // Smooth falloff from center
                    opacity = Math.max(0.03, 0.4 - distance * 0.08);
                  } else {
                    opacity = 0.03;
                  }
                  
                  return (
                    <div 
                      key={index} 
                      className="h-full rounded-full" 
                      style={{ 
                        width: '2px', 
                        backgroundColor: `rgba(250, 247, 245, ${opacity})`
                      }} 
                    />
                  );
                })}
              </div>
              {/* Slider Handle */}
              <div 
                className="absolute h-full w-[10px] rounded-full shadow-[0_4px_12px_rgba(0,0,0,0.4)] cursor-grab active:cursor-grabbing z-10" 
                style={{ 
                  left: `calc(${speedSliderValue}% - 5px)`, 
                  top: '0px',
                  backgroundColor: colors.accent
                }} 
              />
            </div>
            <div className="flex items-center justify-end flex-shrink-0">
              <span className="text-xs font-medium w-[40px] text-right" style={{ color: colors.text.primary }}>
                {speedValue.toFixed(1)}x
              </span>
            </div>
          </div>
          
          {/* Keep Pitch Toggle */}
          <div 
            className="border border-white/10 rounded-lg px-4 py-3 h-[48px] flex justify-between items-center relative cursor-pointer w-full" 
            style={{ backgroundColor: colors.bg.primary }}
            onClick={handleKeepPitchToggle}
          >
            <div className="flex items-center space-x-1 flex-shrink-0">
              <span className="text-xs font-medium" style={{ color: colors.text.primary }}>
                Keep pitch
              </span>
            </div>
            
            <div className="flex items-center space-x-4 flex-shrink-0">
              <div className="flex items-center space-x-4 cursor-pointer">
                <span 
                  className={`text-xs font-medium ${!keepPitch ? '' : 'opacity-30'}`} 
                  style={{ color: colors.text.primary }}
                >
                  Off
                </span>
                <span 
                  className={`text-xs font-medium ${keepPitch ? '' : 'opacity-30'}`} 
                  style={{ color: colors.text.primary }}
                >
                  On
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Hidden audio elements for playback */}
      <audio ref={audioRef} src={audioSrc} preload="metadata" />
      <audio ref={recordingAudioRef} preload="metadata" />
    </div>
  );
};

export default CreateAudioPlayer;